import { useMemo } from 'react';

import { UseScoreCardProvider } from 'components/widgets/ProjectSummary/ProjectSummary.provider';

interface Props {
    api: UseScoreCardProvider['api'];
}

export const useProjectSummaryLogic = ({ api }: Props) => {
    const qualityCardData = useMemo(
        () =>
            api.getProjectStatusScoreCards.instance.data?.summaryCards.find(
                (card) => card?.cardTitle.cardType === 'QualityCard',
            ),
        [api.getProjectStatusScoreCards.instance.data],
    );
    const progressCardData = useMemo(
        () =>
            api.getProjectStatusScoreCards.instance.data?.summaryCards.find(
                (card) => card?.cardTitle.cardType === 'ProgressCard',
            ),
        [api.getProjectStatusScoreCards.instance.data],
    );

    const riskCardData = useMemo(
        () =>
            api.getProjectStatusScoreCards.instance.data?.summaryCards.find(
                (card) => card?.cardTitle.cardType === 'RiskCard',
            ),
        [api.getProjectStatusScoreCards.instance.data],
    );

    const showNoData =
        !riskCardData?.cardProperties && !qualityCardData?.cardProperties && !progressCardData?.cardProperties;

    return {
        logic: {
            qualityCardData,
            progressCardData,
            riskCardData,
            showNoData,
        },
    };
};
